module.exports = __webpack_public_path__ + "static/beshaba-symbol-SCAG-e973672ce0b11f9c576f1ca3a6cfff7e.webp";